<template>
    <div
        class="mb-1 space-y-3 lg:mb-0 lg:flex lg:items-center lg:gap-2 lg:space-y-0 varify-inline-filters:lg:mb-1 varify-inline-filters:lg:block varify-inline-filters:lg:space-y-3"
    >
        <div v-for="filter in filterPanels" :key="filter.filter_identifier" class="lg:min-w-0">
            <div class="mb-2 lg:mb-0 varify-inline-filters:lg:mb-2">
                <HorizontalDragScroll class="gap-2 py-1 md:py-2">
                    <div
                        v-for="index in filter.number_of_values_in_header ?? 6"
                        :key="index"
                        class="h-9 w-20 shrink-0 animate-pulse snap-start rounded-full bg-zinc-200"
                    />
                </HorizontalDragScroll>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import HorizontalDragScroll from '@/components/scroll/HorizontalDragScroll.vue';
import type { CategoryFilterObject } from '@/types/generated';

defineProps<{
    filterPanels: CategoryFilterObject[];
}>();
</script>
